// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2562":"6115a0b064c1a397","6400":"8c3d97e7d46b328b","6666":"1932b9c84b6d0ca6","7117":"98a7d92f3119b30a"}[chunkId] + ".css";
};